import React from "react";

import { Dialog } from "../../hooks/useDialog";

import * as XLSX from "xlsx";

import Button from "@material-ui/core/Button";

import Dropzone from "react-dropzone";
// import FileReader from 'filereader';

import moment from "moment";
import styled from "styled-components";

const ValueHeading = styled.th``;
const ValueCell = styled.td`
  padding: 5px;
  border-top: 1px solid #d8d8d8;
  text-align: center;
`;

function createDataObject(objIn) {
  var ret = {
    portfolioValues: [],
    contributions: [],
    fees: [],
    name: objIn.portfolioName,
  };

  objIn.data
    .sort((a, b) => (a < b ? -1 : 1))
    .forEach((element) => {
      var date = moment(element.date).toDate();

      if (element.value) {
        ret.portfolioValues.push({
          key: `${date.getFullYear()}-${date.getMonth() + 1}`,
          value: element.value,
        });
      }

      var contHandled = false;

      const month = padNumber(date.getMonth() + 1);
      const year = date.getFullYear();
      const day = padNumber(date.getDate());

      var key = `${year}-${month}-${day}`;
      var cont = { key };

      if (element.contribution) {
        cont.contribution = parseFloat(element.contribution);
        contHandled = true;
      }

      if (element.securitiesTransferred) {
        cont.securitiesTransferred = parseFloat(element.securitiesTransferred);
        contHandled = true;
      }

      if (element.cashWithdrawl) {
        cont.cashWithdrawl = parseFloat(element.cashWithdrawl);
        contHandled = true;
      }

      if (element.securitiesWithdrawn) {
        cont.securitiesWithdrawn = parseFloat(element.securitiesWithdrawn);
        contHandled = true;
      }

      if (contHandled) {
        ret.contributions.push(cont);
      }

      var fee = { key };

      if (element.feePaidToManager) {
        fee.feePaidToManager = parseFloat(element.feePaidToManager);

        ret.fees.push(fee);
      }
    });

  return ret;
}

function fixImportObjects(objIn = []) {
  var ret = [];

  objIn
    .sort((a, b) => (a.date > b.date ? 1 : a.date < b.date ? -1 : 0))
    .forEach((element) => {
      var date = moment(element.date).toDate();
      var tmp = JSON.parse(JSON.stringify(element));

      if (
        tmp.value ||
        tmp.contribution ||
        tmp.securitiesTransferred ||
        tmp.securitiesWithdrawn ||
        tmp.cashWithdrawl ||
        tmp.feePaidToManager
      ) {
        tmp.date = date;

        if (tmp.date.toString() !== "Invalid Date") {
          var found = ret.find(
            (e) => e.date.toString() === tmp.date.toString()
          );

          if (found && found.value && tmp.value) {
            found.valueError = true;
          }

          var tmp2 = found ? found : { date: tmp.date };

          if (tmp.value && tmp.value > 0) {
            tmp2.value = parseFloat(tmp.value);

            var f = ret.find(
              (e) =>
                e.value &&
                moment(e.date).format("YYYY-MM") ===
                  moment(tmp.date).format("YYYY-MM")
            );

            if (f && found !== f) {
              tmp2.valueError = true;
            }
          }

          if (tmp.contribution && tmp.contribution > 0) {
            tmp2.contribution =
              ((found && found.contribution) || 0) +
              parseFloat(tmp.contribution);
          }

          if (tmp.securitiesTransferred && tmp.securitiesTransferred > 0) {
            tmp2.securitiesTransferred =
              ((found && found.securitiesTransferred) || 0) +
              parseFloat(tmp.securitiesTransferred);
          }

          if (tmp.cashWithdrawl && tmp.cashWithdrawl > 0) {
            tmp2.cashWithdrawl =
              ((found && found.cashWithdrawl) || 0) +
              parseFloat(tmp.cashWithdrawl);
          }

          if (tmp.securitiesWithdrawn && tmp.securitiesWithdrawn > 0) {
            tmp2.securitiesWithdrawn =
              ((found && found.securitiesWithdrawn) || 0) +
              parseFloat(tmp.securitiesWithdrawn);
          }

          if (tmp.feePaidToManager && tmp.feePaidToManager > 0) {
            tmp2.feePaidToManager =
              ((found && found.feePaidToManager) || 0) +
              parseFloat(tmp.feePaidToManager);
          }

          if (!found) ret.push(tmp2);
        }
      }
    });

  return ret;
}

const padNumber = (value) => {
  return ("0" + value).slice(-2);
};

function convertPPF(objIn = []) {
  var ppf = 0;
  var fullValue = 0;

  var ret = [];

  objIn
    .sort((a, b) => (a.date > b.date ? 1 : a.date < b.date ? -1 : 0))
    .forEach((element) => {
      var tmp = JSON.parse(JSON.stringify(element));

      if (ppf === 0) {
        ppf = tmp.value / 100;
        tmp.value = 100;
      } else if (element.value) {
        tmp.value = tmp.value / ppf;
      }

      if (tmp.contribution) {
        tmp.contribution = tmp.contribution / ppf;
      }

      if (tmp.securitiesTransferred) {
        tmp.securitiesTransferred = tmp.securitiesTransferred / ppf;
      }

      if (tmp.cashWithdrawl) {
        tmp.cashWithdrawl = tmp.cashWithdrawl / ppf;
      }

      if (tmp.securitiesWithdrawn) {
        tmp.securitiesWithdrawn = tmp.securitiesWithdrawn / ppf;
      }

      if (tmp.feePaidToManager) {
        tmp.feePaidToManager = tmp.feePaidToManager / ppf;
      }

      ret.push(tmp);
    });

  return ret;
}

function renderImportCell(value, style = {}) {
  return (
    <ValueCell style={{ style }} title={value}>
      {value ? parseFloat(value.toFixed(8)) : ""}
    </ValueCell>
  );
}

function lastDay(y, m) {
  return new Date(y, m + 1, 0).getDate();
}

function isStartValueValid(value) {
  if (
    value.value &&
    !value.cashWithdrawl &&
    !value.contribution &&
    !value.securitiesTransferred &&
    !value.securitiesWithdrawn &&
    !value.feePaidToManager
  ) {
    return true;
  }
  return false;
}

function allMonthsPresent(values) {
  var fv = values[0];
  var lv = values[values.length - 1];

  var fvd = moment(fv.date).toDate();
  var lvd = moment(lv.date).toDate();

  fvd = new Date(fvd.getFullYear(), fvd.getMonth() + 1, 1);

  lvd = new Date(lvd.getFullYear(), lvd.getMonth(), 1);

  var ret = [];

  while (fvd < lvd) {
    var found = values.filter(
      (e) =>
        moment(e.date).toDate().getMonth() === fvd.getMonth() &&
        moment(e.date).toDate().getFullYear() === fvd.getFullYear() &&
        e.value
    );

    if (found.length === 0) {
      ret.push({
        date: new Date(fvd),
        missing: true,
      });
    }

    fvd.setMonth(fvd.getMonth() + 1);
  }

  return ret;
}

function importedResult(values, dateRange) {
  if (!values || values.length === 0) {
    return "";
  } else {
    var fv = values[0];
    var lv = values[values.length - 1];

    var fvd = moment(fv.date).startOf("day").toDate();
    var lvd = moment(lv.date).startOf("day").toDate();

    var dateCheck = allMonthsPresent(values);

    if (!isStartValueValid(fv)) {
      return "a";
    } else {
      if (fvd.getDate() !== lastDay(fvd.getFullYear(), fvd.getMonth())) {
        return "b";
      } else if (dateCheck.length > 0) {
        if (dateCheck.filter((e) => e.missing).length > 0) {
          return "d";
        } else {
          return "e";
        }
      } else if (fv.value !== 100) {
        return "c";
      } else if (!lv.value) {
        return "f";
      } else if (
        fvd < moment(dateRange.startingDate).startOf("day").toDate() ||
        lvd > moment(dateRange.endDate).startOf("day").toDate()
      ) {
        return "g";
      }
    }
  }
}

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const Render = (props) => {
  const { actions, portfolio, portfolioEntry, onCompleted = () => {} } = props;

  const [showImport, showImport_set] = React.useState(false);
  const [importedData, importedData_set] = React.useState();
  const [, value_set] = React.useState("");

  const { dateRange } = portfolioEntry;

  const importedResultValue = importedResult(
    importedData
      ? importedData.data.sort((a, b) =>
          a.date > b.date ? 1 : a.date < b.date ? -1 : 0
        )
      : null,
    dateRange
  );

  return (
    <div style={{ marginTop: 20 }}>
      <div>
        <div style={{ marginTop: 10 }}>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => {
              value_set("");
              showImport_set(true);
              importedData_set(null);
            }}
          >
            Import Data
          </Button>
        </div>
      </div>
      {showImport && (
        <Dialog
          title={
            importedData && importedData.data.length > 0
              ? "Review Imported Data"
              : "Import From Excel File"
          }
          actionButtons={[
            importedData && importedData.data.length > 0 && (
              <Button
                color="secondary"
                variant="outlined"
                style={{ marginRight: 20 }}
                onClick={() => {
                  importedData_set(null);
                  value_set("");
                }}
              >
                Reset
              </Button>
            ),
            importedData && importedData.data.length > 0 && (
              <Button
                color="primary"
                disabled={importedData.data[0].value !== 100}
                variant="outlined"
                onClick={() => {
                  showImport_set(false);
                  actions.importData(
                    props,
                    portfolio.portfolioNumber,
                    createDataObject(importedData)
                  );
                  onCompleted();
                }}
              >
                Import Data
              </Button>
            ),
            (!importedData || importedData.data.length === 0) && (
              <Button
                color="primary"
                onClick={() => {
                  showImport_set(false);
                }}
              >
                Close
              </Button>
            ),
          ]}
          options={{ maxWidth: importedData ? "lg" : "md", fullWidth: true }}
          onClose={() => {
            showImport_set(false);
          }}
        >
          {showImport && (
            <div>
              {(!importedData || importedData.data.length === 0) && (
                <div>
                  <div></div>
                  <div>
                    <ol>
                      <li style={{ margin: 5 }}>
                        Download the Excel template file by clicking{" "}
                        <a href="/templates/RoboPPA_Template.xlsx">here</a>.
                      </li>
                      <li style={{ margin: 5 }}>
                        Fill in the required data. Make sure to save your data
                        when completed.
                      </li>
                      <li style={{ margin: 5 }}>
                        Import the completed file.
                        <div
                          style={{ margin: 5, fontSize: 14, color: "757575" }}
                        >
                          Note: The file is processed locally on your computer,
                          meaning that the file is kept private and not sent to
                          our servers.
                        </div>
                      </li>
                    </ol>
                  </div>
                  <div style={{ padding: 20 }}>
                    <div>
                      <div>
                        <div style={{ border: "1px dashed #afafaf" }}>
                          <Dropzone
                            name={"import"}
                            accept={".xlsx"}
                            onDrop={(e) => {
                              var reader = new FileReader();

                              reader.addEventListener("loadend", function () {
                                var data1 = new Uint8Array(reader.result);
                                var workbook = XLSX.read(data1, {
                                  type: "array",
                                });

                                const wsname = workbook.SheetNames[0];
                                const ws = workbook.Sheets[wsname];

                                const data = XLSX.utils.sheet_to_json(ws, {
                                  header: 1,
                                });

                                var start = false;

                                const setValue = (
                                  arr,
                                  index,
                                  obj,
                                  propName
                                ) => {
                                  if (index < arr.length && arr[index]) {
                                    if (index === 0) {
                                      var date = new Date(
                                        Math.round(
                                          (arr[index] - 25569) * 86400 * 1000
                                        )
                                      );
                                      date.setDate(date.getDate() + 1);
                                      obj[propName] = date;
                                    } else {
                                      obj[propName] = arr[index];
                                    }
                                  }
                                };

                                var compiled = [];

                                var portfolioName = portfolio.name; //'New Portfolio';

                                data.forEach((row, i) => {
                                  if (row.length > 0) {
                                    if (!start) {
                                      if (
                                        row[0] === "Portfolio Name:" &&
                                        row[1]
                                      ) {
                                        //portfolioName = row[1];
                                      } else if (
                                        row[0] &&
                                        row[0].indexOf("Date") === 0
                                      ) {
                                        start = true;
                                      }
                                    } else {
                                      var rowData = {};

                                      setValue(row, 0, rowData, "date");

                                      if (rowData.date) {
                                        var found = compiled.find(
                                          (e) => e.date === rowData.date
                                        );

                                        //update existing row if there already
                                        if (found) {
                                          rowData = found;
                                        }

                                        //ionly set value if last day
                                        if (
                                          rowData.date.getDate() ===
                                          lastDay(
                                            rowData.date.getFullYear(),
                                            rowData.date.getMonth()
                                          )
                                        )
                                          setValue(row, 1, rowData, "value");

                                        setValue(
                                          row,
                                          2,
                                          rowData,
                                          "contribution"
                                        );
                                        setValue(
                                          row,
                                          3,
                                          rowData,
                                          "securitiesTransferred"
                                        );
                                        setValue(
                                          row,
                                          4,
                                          rowData,
                                          "cashWithdrawl"
                                        );
                                        setValue(
                                          row,
                                          5,
                                          rowData,
                                          "securitiesWithdrawn"
                                        );
                                        setValue(
                                          row,
                                          6,
                                          rowData,
                                          "feePaidToManager"
                                        );

                                        if (!found) compiled.push(rowData);
                                      }
                                    }
                                  }
                                });
                                compiled = fixImportObjects(compiled);
                                importedData_set(
                                  JSON.parse(
                                    JSON.stringify({
                                      portfolioName,
                                      data: compiled,
                                    })
                                  )
                                );
                              });
                              reader.readAsArrayBuffer(e[0]);
                            }}
                          >
                            {({ getRootProps, getInputProps }) => (
                              <section>
                                <div
                                  {...getRootProps()}
                                  style={{ padding: 20, cursor: "pointer" }}
                                >
                                  <input {...getInputProps()} />
                                  <p>
                                    Click or drop the Excel® file here to import
                                    the portfolio data.
                                  </p>
                                </div>
                              </section>
                            )}
                          </Dropzone>
                        </div>
                      </div>
                    </div>
                    {importedData && importedData.data.length === 0 && (
                      <div style={{ color: "red" }}>Invalid data entered.</div>
                    )}
                  </div>
                </div>
              )}
              {importedData && importedData.data.length > 0 && (
                <div>
                  {importedResultValue === "a" && (
                    <Dialog
                      title={"Invalid Data Entered"}
                      actionButtons={[
                        <Button
                          color="secondary"
                          onClick={() => {
                            importedData_set(null);
                            value_set("");
                          }}
                        >
                          Re-enter Values
                        </Button>,
                      ]}
                    >
                      <p>
                        The first entry MUST be the month end portfolio value
                        only. It may not contain any transfers on, or before the
                        start date.
                      </p>
                    </Dialog>
                  )}
                  {importedResultValue === "b" && (
                    <Dialog
                      title={"Invalid Starting Date"}
                      actionButtons={[
                        <Button
                          color="secondary"
                          onClick={() => {
                            importedData_set(null);
                            value_set("");
                          }}
                        >
                          Re-enter Values
                        </Button>,
                      ]}
                    >
                      <p>
                        The first entry must be a Month-End value. The first
                        date found was{" "}
                        {moment(importedData.data[0].date).format(
                          "MMMM DD, YYYY"
                        )}
                      </p>
                    </Dialog>
                  )}
                  {importedResultValue === "c" && (
                    <Dialog
                      title={"Portfolio Privacy Factor Not Found"}
                      actionButtons={[
                        <Button
                          color="secondary"
                          onClick={() => {
                            importedData_set(null);
                            value_set("");
                          }}
                        >
                          Cancel
                        </Button>,
                        <Button
                          color="primary"
                          onClick={() => {
                            importedData_set({
                              portfolioName: importedData.portfolioName,
                              data: convertPPF(importedData.data),
                            });
                          }}
                        >
                          Continue
                        </Button>,
                      ]}
                    >
                      <p>
                        All data must be converted using your Portfolio (Value)
                        Privacy Factor (PPF) to keep your true portfolio values
                        private.
                      </p>
                      <p>
                        The starting portfolio value must equal $100, the value
                        found was $
                        {numberWithCommas(
                          importedData.data[0].value.toFixed(2)
                        )}
                        .
                      </p>
                      <p>
                        If you used your true portfolio values, we can convert
                        your portfolio values using the PPF of{" "}
                        {parseFloat(
                          (importedData.data[0].value / 100).toFixed(8)
                        )}
                      </p>
                      <p>
                        Click "Continue" to use the PPF values, or "Cancel" to
                        re-enter your data.
                      </p>
                    </Dialog>
                  )}
                  {importedResultValue === "d" && (
                    <Dialog
                      title={"Month End Values Missing"}
                      actionButtons={[
                        <Button
                          color="secondary"
                          onClick={() => {
                            importedData_set(null);
                            value_set("");
                          }}
                        >
                          Cancel
                        </Button>,
                      ]}
                    >
                      <p>
                        There were no month end values found for the following
                        months:
                        <ul>
                          {allMonthsPresent(importedData.data)
                            .filter((e) => e.missing)
                            .map((e) => (
                              <li key={e.date.toString()}>
                                {moment(e.date).format("MMMM, YYYY")}
                              </li>
                            ))}
                        </ul>
                      </p>
                      <p>Please fix the values then import again.</p>
                    </Dialog>
                  )}
                  {importedResultValue === "e" && (
                    <Dialog
                      title={"Invalid Portfolio Dates"}
                      actionButtons={[
                        <Button
                          color="secondary"
                          onClick={() => {
                            importedData_set(null);
                            value_set("");
                          }}
                        >
                          Cancel
                        </Button>,
                      ]}
                    >
                      <p>
                        The following dates had month end portfolio values, but
                        were not month end dates.
                        <ul>
                          {allMonthsPresent(importedData.data)
                            .filter((e) => !e.missing)
                            .map((e) => (
                              <li key={e.date.toString()}>
                                {moment(e.date).format("MMMM DD, YYYY")}
                              </li>
                            ))}
                        </ul>
                      </p>
                      <p>Please fix the values then import again.</p>
                    </Dialog>
                  )}
                  {importedResultValue === "f" && (
                    <Dialog
                      title={"Invalid Portfolio End Date"}
                      actionButtons={[
                        <Button
                          color="secondary"
                          onClick={() => {
                            importedData_set(null);
                            value_set("");
                          }}
                        >
                          Cancel
                        </Button>,
                      ]}
                    >
                      <p>The last record entered must have a closing value.</p>
                      <p>Please fix the values then import again.</p>
                    </Dialog>
                  )}
                  {importedResultValue === "g" && (
                    <Dialog
                      title={"Invalid Dates"}
                      actionButtons={[
                        <Button
                          color="secondary"
                          onClick={() => {
                            importedData_set(null);
                            value_set("");
                          }}
                        >
                          Cancel
                        </Button>,
                      ]}
                    >
                      <p>
                        The dates you entered are outside of the allowable
                        dates. Please enter dates between{" "}
                        {moment(dateRange.startingDate).format("MMMM DD, YYYY")}{" "}
                        - {moment(dateRange.endDate).format("MMMM DD, YYYY")}
                      </p>
                      <p>Please fix the values then import again.</p>
                    </Dialog>
                  )}
                  <table
                    style={{
                      border: "1px solid black",
                      borderCollapse: "collapse",
                      width: "100%",
                    }}
                  >
                    <thead>
                      <tr>
                        <th>Date</th>
                        <ValueHeading>Closing Value</ValueHeading>
                        <ValueHeading>Cash Contributions</ValueHeading>
                        <ValueHeading>Securities Contributed</ValueHeading>
                        <ValueHeading>Cash Withdrawn</ValueHeading>
                        <ValueHeading>Securities Withdrawn</ValueHeading>
                        <ValueHeading>Manager Fees Paid</ValueHeading>
                      </tr>
                    </thead>
                    <tbody>
                      {importedData.data
                        .sort((a, b) =>
                          a.date > b.date ? 1 : a.date < b.date ? -1 : 0
                        )
                        .map((e, i) => (
                          <React.Fragment key={`itemRow_${i}`}>
                            <tr>
                              <ValueCell
                                style={{
                                  whiteSpace: "nowrap",
                                  textAlign: "right",
                                }}
                              >
                                {moment(e.date).format("MMM DD, YYYY")}
                              </ValueCell>
                              {renderImportCell(
                                e.value,
                                e.valueError ? { color: "red" } : {}
                              )}
                              {renderImportCell(e.contribution)}
                              {renderImportCell(e.securitiesTransferred)}
                              {renderImportCell(e.cashWithdrawl)}
                              {renderImportCell(e.securitiesWithdrawn)}
                              {renderImportCell(e.feePaidToManager)}
                            </tr>
                            {e.valueError && (
                              <tr>
                                <td></td>
                                <td
                                  colSpan={7}
                                  style={{ color: "red", fontSize: 12 }}
                                >
                                  There are multiple closing values for this
                                  month. Only the last found value will be used.
                                </td>
                              </tr>
                            )}
                          </React.Fragment>
                        ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}
        </Dialog>
      )}
    </div>
  );
};

export default Render;



// WEBPACK FOOTER //
// ./src/portfolioEntryWizard/components/ImportValues.js